import "../../Styles/Landing/SectionOneL.css";
import SectionOneLB1 from "../../Assets/SectionOneLB1.png";
import SectionOneLB2 from "../../Assets/SectionOneLB2.png";
import SectionOneLB3 from "../../Assets/SectionOneLB3.png";
import { useEffect, useState } from "react";

const SectionOneL = () => {
  const images = [SectionOneLB1, SectionOneLB2, SectionOneLB3];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="sectionOneL">
      <div>
        <h1>Begin your Islamic Knowledge Journey</h1>
        <p>Start Your spiritual journey to become a better Muslim woman</p>
      </div>
      <div className="carousel">
        <div className="carouselImages">
          <div className="imageContainer">
            <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="carouselImage" />
            <div className="gradient"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOneL;
